import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactSVG from 'react-svg'
import Loading from '../../../assets/images/loading.svg'

class Loader extends Component {
  render() {
    const { loading, children } = this.props

    return loading ? (
      <div className="loader-container">
        <ReactSVG src={Loading} />
      </div>
    ) : (
      children ? children : <React.Fragment />
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  loading: state.loading
})

export default connect(mapStateToProps)(Loader)
